import { render, staticRenderFns } from "./badge.global.vue?vue&type=template&id=61de05a1&functional=true&"
import script from "./badge.global.vue?vue&type=script&lang=js&"
export * from "./badge.global.vue?vue&type=script&lang=js&"
import style0 from "./badge.global.vue?vue&type=style&index=0&id=61de05a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports